import { saveAs } from "file-saver";

import { DATE_FORMATS_FNS } from "components";
import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";
import { formatDate } from "utils/dateHelperFunctions";

type ExportReportOdsPayload = {
  name: string;
  columns: string[];
  rows: Record<string, unknown>[];
};

export const useExportReportOds = () =>
  useTypedMutation<ExportReportOdsPayload, BlobPart>({
    mutationFn: ({ columns, rows }) => ApiInstance.post("/files/ods", { columns, rows }, ENV.exportBaseURL, { responseType: "blob" }),
    onSuccess: ({ name }, response) =>
      saveAs(new Blob([response], { type: "application/vnd.oasis.opendocument.spreadsheet" }), `${name}_${formatDate(new Date(), DATE_FORMATS_FNS.yearMonthDate)}.ods`)
  });
